var map = {
	"./marker-1.png": 5325,
	"./marker-1@2x.png": 1540,
	"./marker-2.png": 1430,
	"./marker-2@2x.png": 3046,
	"./marker-hover.png": 2571,
	"./marker-hover@2x.png": 7312,
	"./marker-sel.png": 7922,
	"./marker-sel@2x.png": 1898
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7662;